/* ============================================================
   AristoCroc — Base JS
   Fichier : assets/ac-base.js
   Usage   : {{ 'ac-base.js' | asset_url | script_tag }}
   Vanilla JS uniquement. Aucune dépendance externe.
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. FAQ ACCORDION
     Usage : section ac-faq.liquid, ac-product-faq.liquid
  ---------------------------------------------------------- */
  function initFaqAccordions() {
    document.querySelectorAll('.ac-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ac-faq__item');
        var isOpen = item.classList.contains('is-open');

        // Ferme tous les autres dans le même groupe
        var parent = item.closest('.ac-faq__list');
        if (parent) {
          parent.querySelectorAll('.ac-faq__item.is-open').forEach(function (el) {
            el.classList.remove('is-open');
          });
        }

        // Toggle le courant
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  }

  /* ----------------------------------------------------------
     2. FORMAT SELECTOR (fiche produit)
     Sélection du format 3kg / 12kg avec mise à jour du prix
  ---------------------------------------------------------- */
  function initFormatSelector() {
    document.querySelectorAll('.ac-format-selector').forEach(function (selector) {
      var options = selector.querySelectorAll('.ac-format-option');

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          // Retire la sélection actuelle
          options.forEach(function (o) { o.classList.remove('is-selected'); });
          // Sélectionne le cliqué
          opt.classList.add('is-selected');

          // Met à jour l'affichage du prix principal si data-price est défini
          var priceDisplay = document.querySelector('.ac-product-price-main');
          if (priceDisplay && opt.dataset.price) {
            priceDisplay.textContent = opt.dataset.price;
          }

          // Met à jour le microcopy prix/jour si data-perday est défini
          var perdayDisplay = document.querySelector('.ac-product-perday');
          if (perdayDisplay && opt.dataset.perday) {
            perdayDisplay.textContent = opt.dataset.perday;
          }

          // Shopify : met à jour l'input variant si data-variant est défini
          var variantInput = document.querySelector('input[name="id"]');
          if (variantInput && opt.dataset.variant) {
            variantInput.value = opt.dataset.variant;
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------
     3. SUBSCRIPTION TOGGLE (achat unique / abonnement)
  ---------------------------------------------------------- */
  function initSubToggle() {
    document.querySelectorAll('.ac-sub-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var group = opt.closest('.ac-sub-selector');
        if (!group) return;

        group.querySelectorAll('.ac-sub-option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        opt.classList.add('is-selected');

        // Met à jour le prix affiché selon la remise
        var priceMain = document.querySelector('.ac-product-price-main');
        var isSub = opt.dataset.type === 'subscription';

        if (priceMain) {
          var basePrice = parseFloat(priceMain.dataset.base || priceMain.textContent);
          if (isSub) {
            var discount = parseFloat(opt.dataset.discount || 10);
            var discounted = (basePrice * (1 - discount / 100)).toFixed(2);
            priceMain.textContent = discounted + ' €';
          } else {
            priceMain.textContent = priceMain.dataset.base || basePrice + ' €';
          }
        }
      });
    });
  }

  /* ----------------------------------------------------------
     4. STICKY ADD-TO-CART (fiche produit)
     Apparaît quand le hero produit sort du viewport
  ---------------------------------------------------------- */
  function initStickyCart() {
    var stickyBar = document.querySelector('.ac-sticky-cart');
    var hero = document.querySelector('.ac-product-hero');
    if (!stickyBar || !hero) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(hero);
  }

  /* ----------------------------------------------------------
     5. SMOOTH SCROLL pour les ancres internes
  ---------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var offset = 80; // hauteur header sticky
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ----------------------------------------------------------
     6. ANNOUNCEMENT BAR — fermeture
  ---------------------------------------------------------- */
  function initAnnouncementBar() {
    var closeBtn = document.querySelector('.ac-announcement-bar__close');
    var bar = document.querySelector('.ac-announcement-bar');
    if (!closeBtn || !bar) return;

    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      try { sessionStorage.setItem('ac_bar_closed', '1'); } catch (e) {}
    });

    // Vérifie si déjà fermée dans la session
    try {
      if (sessionStorage.getItem('ac_bar_closed') === '1') {
        bar.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ----------------------------------------------------------
     8. HEADER — scroll shadow + sticky
  ---------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.ac-header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     9. INIT GLOBAL
  ---------------------------------------------------------- */
  function init() {
    initFaqAccordions();
    initFormatSelector();
    initSubToggle();
    initStickyCart();
    initSmoothScroll();
    initAnnouncementBar();
    initRationCalculator();
    initHeader();
  }

  // Lancement au DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify — relance après chargement dynamique de sections
  document.addEventListener('shopify:section:load', init);

})();
